$(function() {
  $("#myAccount").click(function() {
    $(this).toggleClass("active");
  });
});